import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface AiScreeningStatsProps {
  allowedProviderScreenings: number
  totalProviderScreened: number
  remainingProviderScreenings: number
}

const AiScreeningStats: React.FC<AiScreeningStatsProps> = ({
  allowedProviderScreenings,
  totalProviderScreened,
  remainingProviderScreenings,
}) => {
  const { formatMessage } = useIntl()
  const hasNoCreditsAvailable = remainingProviderScreenings <= 0

  return (
    <Stack>
      <Stack direction="row" border="1px solid" borderColor="grey.300" borderRadius={2}>
        <Box flex={1} borderRight="1px solid" borderColor="grey.300" p={2}>
          <Typography color="textSecondary" gutterBottom>
            {formatMessage({ id: 'aiScreening.creditsOverview.totalCredits' })}
          </Typography>
          <Typography variant="h6">{allowedProviderScreenings.toLocaleString()}</Typography>
        </Box>
        <Box flex={1} borderRight="1px solid" borderColor="grey.300" p={2}>
          <Typography color="textSecondary" gutterBottom>
            {formatMessage({ id: 'aiScreening.creditsOverview.usedCredits' })}
          </Typography>
          <Typography variant="h6">{totalProviderScreened.toLocaleString()}</Typography>
        </Box>
        <Box
          flex={1}
          p={2}
          sx={({ palette }) => ({
            backgroundColor: hasNoCreditsAvailable ? palette.error.light : 'transparent',
          })}
        >
          <Typography color="textSecondary" gutterBottom>
            {formatMessage({ id: 'aiScreening.creditsOverview.availableCredits' })}
          </Typography>
          <Typography variant="h6">{remainingProviderScreenings.toLocaleString()}</Typography>
        </Box>
      </Stack>
      <Typography color="textSecondary" mt={2}>
        {formatMessage({ id: 'aiScreening.creditsOverview.oneCreditDescription' })}
      </Typography>
    </Stack>
  )
}

export default AiScreeningStats
